// extracted by mini-css-extract-plugin
export var infoSection = "_g-1";
export var infoSectionContainer = "_g-0";
export var infoSectionTitleRow = "_g-2";
export var multiLineInfo = "_g-4";
export var strong = "_g-3";